import { Dialog, useDialogManager } from '../components/widgets/dialog';
import { Input } from '../components/widgets/input';
import { NotificationBanner } from '../components/widgets/notificationBanner';
import { PrimaryButton } from '../components/widgets/buttons';
import { showErrorNotification } from '../components/widgets/notificationToaster';
import React, { FunctionComponent, useState } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { docsDialogQuery } from './__generated__/docsDialogQuery.graphql';
import { docParser } from './zendeskArticlesParser';
import { Hr } from '../components/pages/platformSelection/platformConnection';
import { T } from './helpers';
import { useMutation } from 'react-relay/hooks';
import { connectShopDialogMutation } from './__generated__/connectShopDialogMutation.graphql';
import { ActionContainer, IFrame, IFrameContainer, InstructionItem, InstructionLabel, InstructionsList } from './connectDialogStyle';

const connectShopDoc = graphql`
    query connectShopDialogQuery($id: ID!) {
        zendeskArticle(id: $id) {
            title
            body
        }
    }
`;

const checkWooCommerceStoreUrl = graphql`
    mutation connectShopDialogMutation($urlStore: String!) {
        checkUrlStore(urlStore: $urlStore) {
            validity
            installUrl
        }
    }
`;

export const ConnectShopDialog: FunctionComponent<{
    id: string;
    title?: string;
    titleHtml?: React.ReactNode;
    className?: string;
    windowDecorator?: FunctionComponent<any> | undefined;
    size?: 'small' | 'medium' | 'large' | 'xlarge' | 'fullscreen';
}> = (props) => {
    const [storeUrl, setStoreUrl] = useState('');
    const [checkUrlStore, ischeckUrlStore] = useMutation<connectShopDialogMutation>(checkWooCommerceStoreUrl);

    const { closeDialog } = useDialogManager();
    const Close = () => {
        closeDialog('docs');
    };

    const errorMsg = `Log in to your Wordpress site. Go to <strong><em>Plugins</em> <em>&gt; Add New</em></strong>. Search for <strong>Zakeke</strong> into the
              <em><strong>Search Plugins… </strong></em>field`;

    const htmlContent = useLazyLoadQuery<docsDialogQuery>(connectShopDoc, { id: `guid://Zakeke/ZendeskArticle/${props.id}` });

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent?.zendeskArticle?.body ?? '', 'text/html');

    const dialogContent = docParser(doc, props.id);

    const checkInput = () => {
        if (storeUrl == '') {
            showErrorNotification({ message: T._('Url Store is empty', 'Admin') });
            return false;
        }
        return true;
    };

    const addStore = () => {
        if (checkInput()) {
            try {
                checkUrlStore({
                    variables: {
                        urlStore: storeUrl
                    },
                    onCompleted: (response) => {
                        if (response.checkUrlStore.validity === 'VALID') {
                            window.open(response.checkUrlStore.installUrl!, '_blank');
                        } else {
                            showErrorNotification({
                                message: T._(errorMsg, 'Admin'),
                                dismiss: {
                                    duration: 10000
                                }
                            });
                        }
                    }
                });
            } catch {
                showErrorNotification({
                    message: T._(errorMsg, 'Admin'),
                    dismiss: {
                        duration: 10000
                    }
                });
            }
        }
    };

    return (
        <Dialog title={props.title} titleHtml={props.titleHtml} onClose={Close} windowDecorator={props.windowDecorator} size={props.size}>
            <IFrameContainer>
                {dialogContent.iframeElements[0] && (
                    <IFrame
                        src={dialogContent.iframeElements[0].src ?? ''}
                        width={dialogContent.iframeElements[0].width ?? ''}
                        height={dialogContent.iframeElements[0].height ?? ''}
                    />
                )}
            </IFrameContainer>
            {dialogContent.instructions &&
                dialogContent.instructions.map((instruction, idx) => (
                    <div key={idx}>
                        <InstructionLabel dangerouslySetInnerHTML={{ __html: `${dialogContent.title[idx]} ` }} />
                        <InstructionsList key={idx}>
                            {props.id === '360024308714' && (
                                <InstructionItem>
                                    {`Enter your site’s full URL below`}
                                    <ActionContainer>
                                        <Input
                                            type='text'
                                            placeholder={'http://www.your-website.com'}
                                            value={storeUrl}
                                            onChange={(e) => setStoreUrl(e.currentTarget.value)}
                                        />
                                        <PrimaryButton $size={'medium'} disabled={ischeckUrlStore} onClick={addStore}>
                                            {T._('Integrate Zakeke with your store', 'Admin')}
                                        </PrimaryButton>
                                    </ActionContainer>
                                </InstructionItem>
                            )}
                            {instruction.map(
                                (instruction, subIdx) =>
                                    instruction && <InstructionItem key={subIdx} dangerouslySetInnerHTML={{ __html: `${instruction.text} ` }} />
                            )}
                        </InstructionsList>
                        {idx === 0 && dialogContent.additionalContent?.length > 0 && (
                            <p dangerouslySetInnerHTML={{ __html: `${dialogContent.additionalContent[0]} ` }}></p>
                        )}
                        {dialogContent.instructions.length > 1 && idx < dialogContent.instructions.length - 1 && <Hr />}
                    </div>
                ))}

            {dialogContent.bannerContent && (
                <NotificationBanner content={<div dangerouslySetInnerHTML={{ __html: dialogContent.bannerContent }} />} type={'INFO'}></NotificationBanner>
            )}
        </Dialog>
    );
};
